import {ImgHTMLAttributes} from 'react';
import { Image } from 'rsuite';

interface imageWithFallbackProps extends ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    width: number;
    height: number;
    alt: string;
}
const ImageWithFallback = ({ src, alt, width, height }:imageWithFallbackProps) => {

    return <Image width={width} height={height} src={src} fallbackSrc={width && height ? `https://placehold.co/${width}x${height}` : 'https://placehold.co/200x200'} alt={alt} />;
};

export default ImageWithFallback;